import React, { useRef, useEffect } from 'react';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

window.Trustpilot = window.Trustpilot || null;

export const TrustPilotWidget = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget" // Renamed this to className.
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="55db2f4f0000ff00058282df"
      data-style-height="120"
      data-style-width="238"
      data-theme="light"
    >
      <a
        href="https://www.trustpilot.com/review/www.prosper.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
